
class TripApiService
{

    constructor(tokenManager) {
        this.tokenManager = tokenManager

        let baseURL;

        if(window.location.href.indexOf('localhost') > 0) {
            baseURL = 'https://api-beta.noonlight.com/share/v1'
        } else if(window.location.href.indexOf('beta') > 0 || window.location.href.indexOf('herokuapp.com') > 0) {
            baseURL = 'https://api-beta.noonlight.com/share/v1'
        } else if(window.location.href.indexOf('sandbox') > 0) {
            baseURL = 'https://api-beta.noonlight.com/share/v1'
        } else {
            baseURL = 'https://api.noonlight.com/share/v1'
        }

        this.endpoint = baseURL;
        this.token = this.tokenManager.getToken();
    }

    baseUrl = () => {
        return this.endpoint;
    }
    async oAuthfetchRequest(method = "get", path, body = null) {
        const { token } = this
        const opts = {
            method: method,
            headers: {
                'authorization': `bearer ${token}`,
                'content-type': 'application/json',
            },
            body
        }
        return fetch(`${this.endpoint}/${path}`, opts)
    }

    async fetchTrip (tripId) {
        const response = await this.oAuthfetchRequest("get", `trips/${tripId}`);
        let trip = await response.json()
        return trip
    }

    async activateAlarm(tripId) {
        const status = 'emergency'
        const body = JSON.stringify({status})

        return this.oAuthfetchRequest("post", `trips/${tripId}/statuses`, body);


    }



}

export default TripApiService;



// WEBPACK FOOTER //
// ./src/services/tripApiService.js